// extracted by mini-css-extract-plugin
export default {"item":"DropdownItem_item__IXYXd","icon":"DropdownItem_icon__zRLvs"};